<template>
    <div data-testid="financialclose-home-view">
  <lb-datatableaction :headers="tableHeaders" :tabledata="taskid" :selectfilter="selectfilter" :page_details="page_details" data-testid="financialclose-home-view-datatable"></lb-datatableaction>
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters(['landingCycle']),
  },
  data(){
    return{
      taskid:[],
      selectfilter: {},
      page_details: {},
      tableHeaders: [
              {
                text: 'SL No',
                value: 'indexno',
                visible: true,
                filterable: false,
                sortable: false,
              },
              {
                value: "description",
                text: "Description",
                sortable: false,
                filterable: true,
                visible: true,
              },
              {
                value: "from",
                text: "Start Period",
                sortable: false,
                filterable: true,
                visible: true,
              },
              {
                value: "to",
                text: "End Period",
                sortable: false,
                filterable: true,
                visible: true,
              },
              {
                value: "stage",
                text: "Status",
                sortable: false,
                filterable: false,
                visible: false,
              },
              {
                value: "summary",
                text: "Tasklist Progress",
                sortable: false,
                filterable: false,
                visible: true,
              },
      
              {
                value: "created_at",
                text: "Created At",
                sortable: false,
                filterable: false,
                visible: false,
              },
              {
                value: "updated_at",
                text: "Updated At",
                sortable: false,
                filterable: false,
                visible: false,
              },
              {
                value: "action",
                text: "Action",
                sortable: false,
                filterable: false,
                visible: true,
              },
            ],
        }
    },
   created() {
    this.getProjectsData();
   },
    methods:{
            ...mapActions(['fetchCyclesForSwitcher']),
            async getProjectsData() {
            this.loading = true;
            try {
              await this.fetchCyclesForSwitcher();
              const cycle = this.landingCycle;
              if (!cycle || !cycle._id) {
                console.log('[HomeView]: no open cycle');
                return;
              }
              this.taskid = cycle;
              this.$store.commit('setNewList', [cycle]);
              this.$nova.gotoLink({
                path: '/financialclose/project/checklist/' + cycle._id,
              });
            } catch (err) {
              this.$store.commit('sbError', err.message || 'Unknown error!');
              console.error('[HomeView]: getProjectsData error', err);
            } finally {
              this.loading = false;
            }
    },
    sortByCreatedAtDescending(data){
        return data.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
    },
}
}
</script>